import jsPDF from 'jspdf';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
  }).format(amount || 0);
};

const meses = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const generateWaterReceiptPDF = (parkName, reading) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  
  let y = 20;
  
  // Header
  doc.setFillColor(15, 23, 42); // slate-900
  doc.rect(0, 0, pageWidth, 40, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('NAAVE', 20, 25);
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(parkName, 20, 33);
  
  doc.setFontSize(14);
  doc.text('RECIBO DE CONSUMO DE AGUA', pageWidth - 20, 28, { align: 'right' });
  
  y = 55;
  
  // Reset text color
  doc.setTextColor(0, 0, 0);
  
  // Receipt info box
  doc.setFillColor(248, 250, 252); // slate-50
  doc.rect(15, y, pageWidth - 30, 35, 'F');
  doc.setDrawColor(226, 232, 240); // slate-200
  doc.rect(15, y, pageWidth - 30, 35, 'S');
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Lote:', 20, y + 10);
  doc.text('Propietario:', 20, y + 20);
  doc.text('Medidor:', 20, y + 30);
  
  doc.text('Período:', pageWidth / 2, y + 10);
  doc.text('Fecha Lectura:', pageWidth / 2, y + 20);
  
  doc.setFont('helvetica', 'normal');
  doc.text(reading.numero_lote || '-', 50, y + 10);
  doc.text(reading.propietario_nombre || 'No asignado', 50, y + 20);
  doc.text(reading.numero_medidor || '-', 50, y + 30);
  
  const mesNombre = meses[reading.mes - 1] || '';
  doc.text(`${mesNombre} ${reading.año}`, pageWidth / 2 + 35, y + 10);
  doc.text(reading.fecha_lectura || '-', pageWidth / 2 + 35, y + 20);
  
  y += 50;
  
  // Readings section
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Detalle de Consumo', 15, y);
  y += 10;
  
  // Readings boxes
  const boxWidth = (pageWidth - 45) / 3;
  
  // Lectura Anterior
  doc.setFillColor(255, 255, 255);
  doc.setDrawColor(226, 232, 240);
  doc.rect(15, y, boxWidth, 30, 'FD');
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139); // slate-500
  doc.text('Lectura Anterior', 15 + boxWidth/2, y + 8, { align: 'center' });
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(reading.lectura_anterior?.toString() || '0', 15 + boxWidth/2, y + 22, { align: 'center' });
  
  // Lectura Actual
  doc.setFillColor(255, 255, 255);
  doc.rect(22.5 + boxWidth, y, boxWidth, 30, 'FD');
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100, 116, 139);
  doc.text('Lectura Actual', 22.5 + boxWidth + boxWidth/2, y + 8, { align: 'center' });
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(reading.lectura_actual?.toString() || '0', 22.5 + boxWidth + boxWidth/2, y + 22, { align: 'center' });
  
  // Consumo
  doc.setFillColor(219, 234, 254); // blue-100
  doc.rect(30 + boxWidth * 2, y, boxWidth, 30, 'FD');
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(29, 78, 216); // blue-700
  doc.text('Consumo', 30 + boxWidth * 2 + boxWidth/2, y + 8, { align: 'center' });
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(`${reading.consumo_m3} m³`, 30 + boxWidth * 2 + boxWidth/2, y + 22, { align: 'center' });
  
  y += 45;
  
  // Photo section (if available)
  if (reading.foto_url && reading.foto_url.startsWith('data:image')) {
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Evidencia Fotográfica', 15, y);
    y += 5;
    
    try {
      // Add image
      const imgWidth = 60;
      const imgHeight = 45;
      doc.addImage(reading.foto_url, 'JPEG', 15, y, imgWidth, imgHeight);
      y += imgHeight + 15;
    } catch (e) {
      console.error('Error adding image to PDF:', e);
      y += 10;
    }
  }
  
  // Amounts section
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('Importe', 15, y);
  y += 8;
  
  doc.setFillColor(248, 250, 252);
  doc.rect(15, y, pageWidth - 30, 50, 'F');
  doc.setDrawColor(226, 232, 240);
  doc.rect(15, y, pageWidth - 30, 50, 'S');
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  
  // Price per m3
  doc.text('Precio por m³:', 20, y + 12);
  doc.text(formatCurrency(reading.precio_m3), pageWidth - 25, y + 12, { align: 'right' });
  
  // Base amount
  doc.text('Subtotal (Base):', 20, y + 22);
  doc.text(formatCurrency(reading.monto_base), pageWidth - 25, y + 22, { align: 'right' });
  
  // IVA
  doc.text('IVA (16%):', 20, y + 32);
  doc.text(formatCurrency(reading.monto_iva), pageWidth - 25, y + 32, { align: 'right' });
  
  // Total line
  doc.setDrawColor(200, 200, 200);
  doc.line(20, y + 38, pageWidth - 20, y + 38);
  
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text('TOTAL A PAGAR:', 20, y + 47);
  doc.setTextColor(16, 185, 129); // emerald-500
  doc.text(formatCurrency(reading.monto_total), pageWidth - 25, y + 47, { align: 'right' });
  
  y += 65;
  
  // Footer
  doc.setTextColor(148, 163, 184); // slate-400
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  const footerText = `Generado: ${new Date().toLocaleString('es-MX')}`;
  doc.text(footerText, pageWidth / 2, y, { align: 'center' });
  
  // Save
  const filename = `Recibo_Agua_${reading.numero_lote}_${meses[reading.mes - 1]}_${reading.año}.pdf`;
  doc.save(filename);
};

export default generateWaterReceiptPDF;
